module.exports = __webpack_public_path__ + "static/img/idcard_back.e667f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/idcard_back.png
// module id = /hGg
// module chunks = 1